export const APP_API_SERVER = "https://avatars.bot.media/api";
